import { stack as d3_stack, stackOffsetDiverging as d3_stackOffsetDiverging } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'

export default function WaterfallDataController(rows, config = {}, hiddenItems) {
  let headers = rows[0]
  let propperHeaders
  let dims

  propperHeaders = ['id', 'value']
  let typesIdx = headers.findIndex(d => d === 'type')
  let types = typesIdx > 0 ? rows.map(r => r[typesIdx]).slice(1) : null
  if (!types) types = rows.slice(1).map((d, i) => (i === 0 ? 'initial value' : 'variation'))
  if (types) rows = rows.map(row => row.filter((d, i) => i !== typesIdx))
  dims = 1

  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)
  if (hiddenItems) data = data.filter(d => hiddenItems.indexOf(d.id) < 0)
  //Sort data by mode
  // if (config.dataSorting !== 'none') {
  //   if (config.mode === 'stacked') {
  //     data.sort((a, b) => {
  //       let aAddition = a.value.reduce((accumulator, current) => (accumulator += current.value), 0)
  //       let bAddition = b.value.reduce((accumulator, current) => (accumulator += current.value), 0)
  //       let diff = aAddition - bAddition
  //       return config.dataSorting === 'asc' ? diff : -diff
  //     })
  //   } else {
  //     data.sort((a, b) => {
  //       let diff = a.value - b.value
  //       return config.dataSorting === 'asc' ? diff : -diff
  //     })
  //   }
  // }

  // let extent
  // if (config.mode === 'stacked') {
  //   extent = [
  //     d3_min(data, d => d3_min(d.value, dd => dd.value)),
  //     d3_max(data, d => d3_max(d.value, dd => dd.value)),
  //   ]
  // } else if (config.mode === 'grouped') {
  //   extent = [
  //     d3_min(data, d => d3_min(d.value, dd => dd.value)),
  //     d3_max(data, d => d3_max(d.value, dd => dd.value)),
  //   ]
  // } else {
  //   extent = d3_extent(data, d => d.value)
  // }
  // if (extent[0] > 0) extent[0] = 0

  if (config.computedTotal) {
    let total = data.reduce((tot, val) => {
      tot += val.value
      return tot
    }, 0)
    data = [
      ...data,
      {
        id: config.computedTotal,
        value: total,
        type: 'total',
      },
    ]
    types = [...types, 'total']
  }
  let extent = d3_extent(data, d => d.value)
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  let waterData = data.reduce((res, d, i) => {
    if (!d.id) d.id = i
    let prev = i === 0 ? { y1: 0 } : res[i - 1]

    d.y0 = types && types[i] === 'total' ? 0 : prev.y1
    d.y1 = d.y0 + d.value

    d.safeValue = getSafeValue(d.value)
    res.push(d)
    return res
  }, [])
  waterData.forEach((d, i) => {
    if (d.y0 > d.y1) {
      let tmp = d.y0
      d.y0 = d.y1
      d.y1 = tmp
      d.colorType = 'negative'
    } else {
      d.colorType = 'positive'
    }

    if (types) {
      d.type = types[i]
      if (d.type === 'total') d.colorType = 'total'
      if (d.type === 'initial value') d.colorType = 'initial value'
    }
    d.barMax = d.y0
    d.barMin = d.y1
  })
  waterData.forEach((d, i) => {
    d.isLast = i === waterData.length - 1 || (i > 0 && types && types[i + 1] === 'total')
  })
  return waterData
}
